import React, { useState } from 'react';
export var QuickAddModalContext = React.createContext({});
var QuickAddModalProvider = function (_a) {
    var children = _a.children;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = useState({}), quickAddModalProps = _c[0], setQuickAddModalProps = _c[1];
    var handleClose = function () {
        setIsOpen(false);
    };
    var handleOpen = function (modalProps) {
        setIsOpen(true);
        setQuickAddModalProps(modalProps);
    };
    return (React.createElement(QuickAddModalContext.Provider, { value: {
            isOpen: isOpen,
            quickAddModalProps: quickAddModalProps,
            handleOpen: handleOpen,
            handleClose: handleClose
        } }, children));
};
/**
 * Custom hook for adding QuickAddModal functionality to a component
 */
export var useQuickAddModal = function () {
    var context = React.useContext(QuickAddModalContext);
    if (context === null) {
        throw new Error('useQuickAddModal must be used within a QuickAddModalProvider');
    }
    return context;
};
export default QuickAddModalProvider;
